import { Head, Link, useForm } from "@inertiajs/react"
import AuthLayout from "@/components/auth/layout"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"

export default function ForgotPassword() {
  const { data, setData, post, processing, errors, transform } = useForm({
    email: "",
  })

  transform((d) => ({ user: d }))

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    post("/password")
  }

  return (
    <>
      <Head title="Forgot Password | QuiteRight" />
      <AuthLayout
        heading="Reset your password"
        subheading="Enter your email and we'll send you reset instructions."
      >
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="email">Email address</Label>
            <Input
              id="email"
              type="email"
              value={data.email}
              onChange={(e) => setData("email", e.target.value)}
              placeholder="jane@example.co.uk"
              className="mt-1.5"
              autoComplete="email"
              required
            />
            {errors.email && (
              <p className="mt-1 text-xs text-red">{errors.email}</p>
            )}
          </div>

          <Button
            type="submit"
            disabled={processing}
            className="w-full bg-red py-5 text-sm font-semibold text-white hover:bg-red-deep"
          >
            {processing ? "Sending..." : "Send reset instructions"}
          </Button>
        </form>

        <p className="mt-6 text-center text-sm text-warm-grey">
          Remember your password?{" "}
          <Link
            href="/sign-in"
            className="font-medium text-charcoal underline-offset-4 hover:underline"
          >
            Sign in
          </Link>
        </p>
      </AuthLayout>
    </>
  )
}
